import API from './api';

export const fetchConfig = () =>
  API.get('/Config')
    .then(res => res)
    .catch(err => {
      throw err;
    });
